import AccountSettings from './AccountSettingsCtnr';

export default AccountSettings;
